<template>
  <div class="forum-list">
    <!-- 论坛 -->
    <dl class="show-flex-box-r" v-if= "listInfo">
      <dt class="show-flex-box-c">
        <span class="head-portrait">
          <img :src= "listInfo.user.avatar" alt="德阳经开科创" draggable="false" class="head-portrait-pic">
          <span class="user-lv" :class= "'lv-'+listInfo.user.vip.level"></span>
        </span>
        <strong class="user-name">{{listInfo.user.nickname}}</strong>
      </dt>
      <dd class="show-flex-box-r" @click="tabToForumDetail">
        <span class="list-center show-flex-box-c">
          <span class="post-title show-flex-box-r">
            <span class="set-top" v-if= "listInfo.top">置顶</span>
            <span class="official" v-if= "listInfo.type == 'official'">官方</span>
            <h1>{{listInfo.title}}</h1>
          </span>
          <h3>{{listInfo.summary}}</h3>
          <span class="post-status-details show-flex-box-r">
            <span class="readed-number"></span>
            <strong>{{listInfo.view}}</strong>
            <span class="like-account"></span>
            <strong>{{listInfo.praise}}</strong>
            <span class="release-time"></span>
            <strong>{{listInfo.time | formatDate('MM-dd hh:mm')}}</strong>
          </span>
        </span>
        <span class="post-pic" v-if= "listInfo.logo"><img :src= "listInfo.logo" alt=""></span>
      </dd>
    </dl>
    <!-- 机构论坛 -->
    <dl class="show-flex-box-r" v-if= "postTeacherForumList">
      <dt class="show-flex-box-c">
        <span class="head-portrait">
          <img :src= "postTeacherForumList.user.avatar" alt="德阳经开科创" draggable="false" class="head-portrait-pic">
          <span class="user-lv" :class= "'lv-'+postTeacherForumList.user.vip.level"></span>
        </span>
        <strong class="user-name">{{postTeacherForumList.user.nickname}}</strong>
      </dt>
      <dd class="show-flex-box-r" @click="tabToTeacherForumDetail">
        <span class="list-center show-flex-box-c">
          <span class="post-title show-flex-box-r">
            <span class="set-top" v-if= "postTeacherForumList.top">置顶</span>
            <span class="official" v-if= "postTeacherForumList.type == 'official'">官方</span>
            <h1>{{postTeacherForumList.title}}</h1>
          </span>
          <h3>{{postTeacherForumList.summary}}</h3>
          <span class="post-status-details show-flex-box-r">
            <span class="readed-number"></span>
            <strong>{{postTeacherForumList.view}}</strong>
            <span class="like-account"></span>
            <strong>{{postTeacherForumList.praise}}</strong>
            <span class="release-time"></span>
            <strong>{{postTeacherForumList.created_at | formatDate('MM-dd hh:mm')}}</strong>
          </span>
        </span>
        <span class="post-pic" v-if= "postTeacherForumList.logo"><img :src= "postTeacherForumList.logo.o" draggable="false" alt="德阳经开科创"></span>
      </dd>
    </dl>
  </div>
</template>

<script>
export default {
  name: 'forum_list_cpn',
  props: {
    'listInfo' : [Number,String,Object],
    'postTeacherForumList': [String,Object,Array]
  },
  data () {
    return {

    }
  },
  methods:{
    tabToForumDetail: function() {
      let toWhere = '/forum/forum_detail/ids';
      this.$router.push({'path':toWhere,query:{forumDetailsId:this.listInfo.id,forumKind: 'forum'}});
    },
    tabToTeacherForumDetail: function() {
      let toWhere = '/mars_box_ins/ins_teacher_home/forum_detail/teacherForum';
      this.$router.push({'path':toWhere,query:{forumDetailsId: this.postTeacherForumList.id, forumKind: 'teacherForum'}});
    }
  },
  mounted() {

  }
}
</script>

<style lang="less" scoped>
  .forum-list{
    width: 100%;
    height: 100%;
    dl{
      width: 100%;
      height: 100%;
      dt{
        display: flex;
        align-items: center;
        justify-content: center;
        .head-portrait{
          display: block;
          width: 46px;
          height: 46px;
          border-radius: 50%;
          padding-bottom: 16px;
          .head-portrait-pic{
            border-radius: 50%;
            overflow: hidden;
            width: 100%;
            height: 100%;
          }
          .user-lv{
            display: block;
            position: relative;
            top: -16px;
            left: 20px;
            width: 42px;
            height: 18px;
          }
          .lv-1{
            background: url('../../assets/forum/LV1.png') no-repeat center center;
            background-size: cover;
          }
          .lv-2{
            background: url('../../assets/forum/LV2.png') no-repeat center center;
            background-size: cover;
          }
          .lv-3{
            background: url('../../assets/forum/LV3.png') no-repeat center center;
            background-size: cover;
          }
          .lv-4{
            background: url('../../assets/forum/LV4.png') no-repeat center center;
            background-size: cover;
          }
          .lv-5{
            background: url('../../assets/forum/LV5.png') no-repeat center center;
            background-size: cover;
          }
          .lv-6{
            background: url('../../assets/forum/LV6.png') no-repeat center center;
            background-size: cover;
          }
          .lv-7{
            background: url('../../assets/forum/LV7.png') no-repeat center center;
            background-size: cover;
          }
          .lv-8{
            background: url('../../assets/forum/LV8.png') no-repeat center center;
            background-size: cover;
          }
          .lv-9{
            background: url('../../assets/forum/LV9.png') no-repeat center center;
            background-size: cover;
          }
          .lv-10{
            background: url('../../assets/forum/LV10.png') no-repeat center center;
            background-size: cover;
          }
        }
        .user-name{
          width: 60px;
          display: block;
          font-size: 14px;
          font-weight: 400;
          text-align: center;
          color: #555;
          word-break:keep-all;
          white-space:nowrap;
          overflow:hidden;
          text-overflow:ellipsis;
        }
      }
      dd{
        width: 0;
        flex-grow: 1;
        padding-left: 28px;
        align-items: center;
        cursor: pointer;
        // justify-content: space-between;
        .list-center{
          display: block;
          width: 0;
          flex-grow: 1;
          .post-title{
            display: flex;
            align-items: center;
            padding-bottom: 10px;
            overflow: hidden;
            span{
              display: block;
              width: 50px;
              height: 20px;
              border-radius: 4px;
              text-align: center;
              line-height: 20px;
              color: #fff;
              // margin-right: 11px;
            }
            .set-top{
              display: block;
              background: #ff7800;
              margin-right: 11px;
            }
            .official{
              display: block;
              background: #6D9DF5;
              margin-right: 11px;
            }
            h1{
              width: 0;
              flex-grow: 1;
              display: block;
              font-size: 18px;
              font-weight: 400;
              color: #555;
              word-break:keep-all;
              white-space:nowrap;
              overflow:hidden;
              text-overflow:ellipsis;
            }
          }
          h3{
            display: block;
            font-size: 14px;
            overflow:hidden;
            font-weight: 400;
            color: #999;
            word-break:keep-all;
            white-space:nowrap;
            text-overflow:ellipsis;
            padding-bottom: 16px;
          }
          .post-status-details{
            display: flex;
            align-items: center;
            strong{
              display: block;
              font-size: 14px;
              font-weight: 500;
              color: #bdbdbd;
            }
            .readed-number{
              width: 22px;
              height: 16px;
              background: url('../../assets/personal/read.png') no-repeat center center;
              background-size: cover;
              margin-right: 11px;
            }
            .like-account{
              width: 16px;
              height: 16px;
              background: url('../../assets/personal/like.png') no-repeat center center;
              background-size: cover;
              margin-left: 24px;
              margin-right: 10px;
            }
            .release-time{
              width: 16px;
              height: 16px;
              background: url('../../assets/personal/time.png') no-repeat center center;
              background-size: cover;
              margin-left: 40px;
              margin-right: 10px;
            }
          }
        }
        .post-pic{
          display: flex;
          width: 90px;
          height: 90px;
          overflow: hidden;
          padding-left: 50px;
          img{
            display: block;
            flex-grow: 1;
            width: 100%;
            object-fit: cover;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/forum/forum_list_cpn.vue